import React, { useEffect, useMemo, useState } from 'react';
import MainContainer from '../../../components/MainContainer';
import { headerDataImmo } from '../../../data/modules/logistic-header';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  TableRow,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
  Box,
  TextField,
  FormControl,
  Chip,
} from '@mui/material';
import { makeStyles } from '@material-ui/core';
import { useLocation, useNavigate, useParams } from 'react-router';
import MissionTransportService from '../../../services/MissionTransportService';
import ProvisionalFuelMissionService from '../../../services/ProvisionalFuelMissionService';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import Message from '../../tools/Message';
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import CardTravelIcon from '@mui/icons-material/CardTravel';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import MissionSummaryService from '../../../services/MissionSummaryService';
import Bullred from '../../../components/reusable/Bullred';
import { stickyHeaderCellSx, stickySubHeaderCellSx } from '../../../styles/TableStyle.style';
import formatWithThousandSeparator from '../../../helpers/FormatWithThousandSeparator';
import DestinationDriverDialog from './DestinationDriverDialog';
import TimeSheetMissionService from '../../../services/TimeSheetMissionService';
const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    elevation: 2,
    borderRadius: '8px !important',
    marginTop: '1.5%',
    boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;',
    width: '100%',
  },
  dialog: {
    width: '99%',
    height: '99%',
    justifyContent: 'center',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '20px',
    fontSize: '12px',
  },
  fieldset: {
     borderRadius: "10px",
    // color: "#1976d2",
    fontSize: "20px",
    marginTop: "10px",
    overflowX: "auto", 
    padding: "10px",
    maxWidth: "98vw",
    width: "98vw",
     backgroundColor: "#ffffff",
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.05)",
    border: "1px solid #d7e1f3",
    "& legend": {
      padding: "0 10px",
      color: "#2f5ca3",
      fontWeight: 700,
      letterSpacing: "0.2px",
    },
  },
}));

const TimesheetDriver = () => {
  const { mission_planning_id, agenda_id, mission_timesheet_id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const classes = useStyles();
  const searchParams = new URLSearchParams(location.search);

  const selectedTransportIds = useMemo(() => {
    if (Array.isArray(location.state?.transport_ids) && location.state.transport_ids.length > 0) {
      return location.state.transport_ids.map((id) => Number(id)).filter(Boolean);
    }
    const raw = searchParams.get('transport_ids');
    if (!raw) {
      return [];
    }
    return raw
      .split(',')
      .map((id) => Number(id))
      .filter(Boolean);
  }, [location.state, location.search]);

  const returnPath = location.state?.from || '/Logistic/mission/timesheet';
  const [mission, setMission] = useState(null);
  const [transportData, setTransportData] = useState([]);
  const [rowsByTransport, setRowsByTransport] = useState({});
  const [removedRowsByTransport, setRemovedRowsByTransport] = useState({});
  const [loadingBackdrop, setLoadingBackdrop] = useState(false);
  const [destDialog, setDestDialog] = useState({
    open: false,
    agenda_id: null,
    mission_timesheet_id: null,
    missionnaries: [],
    mode: 'add',
    destination: null,
    transport_id: null,
    onClose: () => setDestDialog((prev) => ({ ...prev, open: false })),
  });
  const [message, setMessage] = useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;

  const handleCloseMessage = () => {
    setMessage({ ...message, open: false });
  };

  const handleCloseDialog = () => {
    navigate('/logistic/mission/transport_managment');
  };

  const handleOpenDestinationDialog = (transportId) => {
    setDestDialog({
      open: true,
      agenda_id,
      mission_timesheet_id,
      missionnaries: mission?.missionnaries || [],
      mode: 'add',
      destination: null,
      transport_id: transportId || null,
      onClose: () => setDestDialog((prev) => ({ ...prev, open: false })),
    });
  };

  const handleEditDestinationDialog = (transportId, destination) => {
    if (!destination?.mission_timesheet_destination_id) {
      return;
    }
    setDestDialog({
      open: true,
      agenda_id,
      mission_timesheet_id,
      missionnaries: mission?.missionnaries || [],
      mode: 'edit',
      destination,
      transport_id: transportId || destination.transport_id || null,
      onClose: () => setDestDialog((prev) => ({ ...prev, open: false })),
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) {
      return '';
    }
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
      return dateString;
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const fetchData = async () => {
    setLoadingBackdrop(true);
    try {
      const transportsResult = await MissionTransportService.transportsByMissionPlanning(
        mission_planning_id,
        agenda_id
      );
      if (!transportsResult || !transportsResult.status) {
        setMessage({
          open: true,
          color: 'red',
          messageInfo: transportsResult?.message || 'Erreur lors du chargement des transports.',
        });
        return;
      }

      let transports = Array.isArray(transportsResult.data) ? transportsResult.data : [];
      transports = transports.filter((transport) => (transport?.vhc_type || transport?.type) === 'FID');
      if (selectedTransportIds.length > 0) {
        transports = transports.filter((transport) => selectedTransportIds.includes(Number(transport.transport_id)));
      }

      setTransportData(transports);

      const rowsMap = {};
      const removedMap = {};

      await Promise.all(
        transports.map(async (transport) => {
          const response = await ProvisionalFuelMissionService.getTimesheetVehicleDetails(transport.transport_id, mission_timesheet_id);
          const rows = response?.status && Array.isArray(response.data) ? response.data : [];
          rowsMap[transport.transport_id] = rows.map((row, index) => ({
            ...row,
            _rowKey:
              row.mission_timesheet_fuel_id ||
              row.mission_destination_id ||
              row.mission_timesheet_destination_id ||
              `${transport.transport_id}-${index}`,
          }));
          removedMap[transport.transport_id] = [];
        })
      );

      setRowsByTransport(rowsMap);
      setRemovedRowsByTransport(removedMap);
    } catch (error) {
      console.error('Error fetching driver timesheet data:', error);
      setMessage({
        open: true,
        color: 'red',
        messageInfo: 'Erreur lors du chargement des donnees du timesheet chauffeur.',
      });
    } finally {
      setLoadingBackdrop(false);
    }
  };
  const refreshDestinations = () => {
    fetchData();
  };
  const fetchMissionData = async () => {
    try {
      const missionResult = await MissionSummaryService.getMissionData(mission_planning_id, agenda_id);
      if (missionResult && missionResult.status) {
        setMission(missionResult.data);
      }
    } catch (error) {
      console.error('Error fetching mission data:', error);
    }
  };

  useEffect(() => {
    if (mission_planning_id && agenda_id) {
      fetchData();
      fetchMissionData();
    }
  }, [mission_planning_id, agenda_id, mission_timesheet_id]);

  const handleRemoveRow = (transportId, rowKey) => {
    setRowsByTransport((prev) => {
      const updated = { ...prev };
      const rows = [...(updated[transportId] || [])];
      const rowIndex = rows.findIndex((row) => row._rowKey === rowKey);
      if (rowIndex === -1) {
        return prev;
      }
      const [removedRow] = rows.splice(rowIndex, 1);
      updated[transportId] = rows;
      setRemovedRowsByTransport((prevRemoved) => {
        const nextRemoved = { ...prevRemoved };
        nextRemoved[transportId] = [...(nextRemoved[transportId] || []), removedRow];
        return nextRemoved;
      });
      return updated;
    });
  };

  const handleAddRow = (transportId) => {
    setRemovedRowsByTransport((prevRemoved) => {
      const removed = prevRemoved[transportId] || [];
      if (!removed.length) {
        setMessage({
          open: true,
          color: 'red',
          messageInfo: "Aucune ligne a ajouter pour ce transport.",
        });
        return prevRemoved;
      }
      const [restored, ...remaining] = removed;
      setRowsByTransport((prevRows) => {
        const rows = [...(prevRows[transportId] || [])];
        rows.push(restored);
        return { ...prevRows, [transportId]: rows };
      });
      return { ...prevRemoved, [transportId]: remaining };
    });
  };

  const buildTimesheetDestination = (transport, row) => {
    const rawKm =
      row.distance_km !== undefined && row.distance_km !== ''
        ? row.distance_km
        : row.mission_timesheet_details_km;
    const km = Number(rawKm || 0);
    return {
      mission_destination_id: row.mission_destination_id || null,
      mission_timesheet_destination_id: row.mission_timesheet_destination_id || null,
      mission_planning_agenda_id: agenda_id || null,
      observation: row.observation || '',
      date_begin: row.date_begin || null,
      date_end: row.date_end || null,
      heure_begin: row.heure_begin || null,
      heure_end: row.heure_end || null,
      type: row.type || null,
      activite: row.activite || null,
      code_financement_mis: row.code_financement_mis || '',
      id_financement_mis: row.id_financement_mis || null,
      transport_type: row.transport_type || null,
      distance_km: km,
      mission_timesheet_fuel_id: row.mission_timesheet_fuel_id || null,
      region_depart: row.region_depart || '',
      district_depart: row.district_depart || '',
      commune_depart: row.commune_depart || '',
      fokontany_depart: row.fokontany_depart || '',
      region_arrivee: row.region_arrivee || '',
      district_arrivee: row.district_arrivee || '',
      commune_arrivee: row.commune_arrivee || '',
      fokontany_arrivee: row.fokontany_arrivee || '',
      mission_rent_id: row.mission_rent_id || null,
      night_number: row.night_number || 0,
      transport_id: row.transport_id || transport.transport_id,
    };
  };

  const handleSave = async () => {
    if (!transportData.length) {
      setMessage({
        open: true,
        color: 'red',
        messageInfo: 'Aucun transport FID a traiter.',
      });
      return;
    }
    setLoadingBackdrop(true);
    try {
      const timesheetDestinations = [];
      for (const transport of transportData) {
        const rows = rowsByTransport[transport.transport_id] || [];
        if (!rows.length) {
          setMessage({
            open: true,
            color: 'red',
            messageInfo: `Aucune ligne a enregistrer pour le vehicule ${transport.vhc_imm || ''}.`,
          });
          return;
        }
        const isValid = rows.every((row) => {
          const kmValue =
            row.distance_km !== undefined && row.distance_km !== ''
              ? row.distance_km
              : row.mission_timesheet_details_km;
          return kmValue !== undefined && kmValue !== '';
        });
        if (!isValid) {
          setMessage({
            open: true,
            color: 'red',
            messageInfo: 'Veuillez renseigner tous les kilometrages avant d\'enregistrer.',
          });
          return;
        }
        rows.forEach((row) => {
          timesheetDestinations.push(buildTimesheetDestination(transport, row));
        });
      }

      const parsedTimesheetId = Number(mission_timesheet_id || 0);
      const payload = {
        mission_planning_id: mission_planning_id || null,
        mission_timesheet_id: parsedTimesheetId || null,
        mission_planning_agenda_id: agenda_id || null,
        action: parsedTimesheetId ? 'update' : 'create',
        timesheet_destinations: timesheetDestinations,
      };

      const response = await TimeSheetMissionService.saveTimesheetMission(payload);
      if (!response || !response.status) {
        setMessage({
          open: true,
          color: 'red',
          messageInfo: response?.message || 'Erreur lors de l\'enregistrement du timesheet chauffeur.',
        });
        return;
      }

      const driverOM = await MissionTransportService.sendDriverOM(
        mission_planning_id,
        agenda_id
      );
      if (!driverOM || !driverOM.status) {
        setMessage({
          open: true,
          color: 'red',
          messageInfo: driverOM?.message || "Erreur lors de l'envoi de l'OM chauffeur.",
        });
        return;
      }

      setMessage({
        open: true,
        color: 'green',
        messageInfo: 'Timesheet chauffeur enregistre et OM envoye avec succes.',
      });
      navigate(returnPath);
    } catch (error) {
      setMessage({ open: true, color: 'red', messageInfo: error?.message || 'Erreur lors de l\'enregistrement du timesheet chauffeur.' });
    } finally {
      setLoadingBackdrop(false);
    }
  };

  const handleChangeKm = (e, transportId, rowKey) => {
    const { value } = e.target;
    const parsedValue = value === '' ? '' : Number(value);
    const transport = transportData.find((item) => item.transport_id === transportId);
    const conso100 = Number(transport?.vhc_conso_100km || 0);
    const pricePerLiter = Number(transport?.price_per_liter || 0);
    setRowsByTransport((prev) => {
      const updated = { ...prev };
      const rows = [...(updated[transportId] || [])];
      const rowIndex = rows.findIndex((row) => row._rowKey === rowKey);
      if (rowIndex === -1) {
        return prev;
      }
      const nextValue = Number.isNaN(parsedValue) ? '' : parsedValue;
      const kmValue = nextValue === '' ? 0 : Number(nextValue || 0);
      const consumptionValue = (kmValue * conso100) / 100;
      const amountValue = consumptionValue * pricePerLiter;
      rows[rowIndex] = {
        ...rows[rowIndex],
        distance_km: nextValue,
        mission_timesheet_details_km: nextValue,
        mission_timesheet_details_consumption: nextValue === '' ? '' : consumptionValue,
        mission_timesheet_details_amount: nextValue === '' ? '' : amountValue,
      };
      updated[transportId] = rows;
      return updated;
    });
  };

  return (
    <MainContainer {...headerDataImmo}>
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={loadingBackdrop} />
      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        fullScreen
        aria-labelledby="form-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
      >
        <DialogTitle id="form-dialog-title">Timesheet chauffeur associé à la mission {mission?.reference || ''}</DialogTitle>
        <DialogContent dividers>
          <DialogContentText sx={{ fontSize: '12px', color: '#8e9194ff' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} display="flex" justifyContent="flex-end">
                <Button variant="outlined" color="info" onClick={() => fetchData()}>
                  Rafraichir
                </Button>
              </Grid>

              {transportData.length > 0 ? (
                transportData.map((transport, index) => {
                  const rows = rowsByTransport[transport.transport_id] || [];
                  const totalKm = rows.reduce((sum, row) => sum + Number(row.mission_timesheet_details_km || 0), 0);
                  const totalConsumption = (totalKm * Number(transport.vhc_conso_100km || 0)) / 100;
                  const totalAmount = (totalKm * Number(transport.vhc_conso_100km || 0) * Number(transport.price_per_liter || 0)) / 100;

                  return (
                    <Grid container key={transport.transport_id}>
                      <fieldset className={classes.fieldset}>
                        <legend >
                          {`${transport.vhc_imm || ''} - ${transport.vhc_type || ''}`}
                        </legend>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item xs={12} md={4}>
                            <label style={{ fontSize: '14px' }}>
                              Chauffeur : <strong>{transport.driver_name || '-'}</strong>
                            </label><br/>
                            <label style={{ fontSize: '14px' }}>
                              Chef de bord : <strong>{transport.captain_name || '-'}</strong>
                            </label>
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <label style={{ fontSize: '14px' }}>
                              Consommation (L/100km) : <strong>{transport.vhc_conso_100km || '-'} L</strong>
                            </label><br/>
                            <label style={{ fontSize: '14px' }}>
                              Prix unitaire du litre : <strong>{formatWithThousandSeparator(transport.price_per_liter) || '-'} Ariary</strong>
                            </label>
                          </Grid>
                          <Grid item xs={12} md={4} display="flex" justifyContent="flex-end">
                            <Button
                              variant="outlined"
                              color="info"
                              startIcon={<AddIcon />}
                              onClick={() => handleOpenDestinationDialog(transport.transport_id)}
                            >
                              Ajouter une ligne
                            </Button>
                          </Grid>
                        </Grid>

                        <Paper className={classes.paper}>
                        <TableContainer sx={{maxWidth: "90.88vw", width: "100%", height: "580px", overflowX: "auto", overflowY: "auto"}}>
                          <Table>
                            <TableHead>
                              <TableRow sx={{ "& th": stickyHeaderCellSx }}>
                                    <TableCell rowSpan={2} sx={{ minWidth: '4px'}}></TableCell>
                                    <TableCell rowSpan={2} sx={{ maxWidth: '100px', textAlign: "center" }}>Date(s)</TableCell>
                                    <TableCell rowSpan={2} sx={{ maxWidth: '80px', textAlign: "center" }}>Heure départ</TableCell>
                                    <TableCell rowSpan={2} sx={{ maxWidth: '80px', textAlign: "center" }}>Heure arrivée</TableCell>
                                    <TableCell colSpan={5} sx={{ minWidth: '210px', textAlign: "center"}}>Lieu de départ</TableCell>
                                    <TableCell colSpan={5} sx={{ minWidth: '210px', textAlign: "center"}}>Lieu d'arrivée</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '60px', textAlign: "center" }}>Type</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '130px', textAlign: "center" }}>Financement</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '130px', textAlign: "center" }}>Estimation Kilométrage</TableCell>
                                    {/* <TableCell rowSpan={2} sx={{ minWidth: '220px', textAlign: "center" }}>Moyen de transport <Bullred/></TableCell> */}
                                    <TableCell rowSpan={2} sx={{ minWidth: '140px', textAlign: "center" }}>Consommation en l</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '140px', textAlign: "center" }}>Estimation prix unitaire en Ar</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '140px', textAlign: "center" }}>Carburant en Ar</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '100px', textAlign: "center" }}>Nombre de nuitées</TableCell>
                                    <TableCell rowSpan={2} sx={{ minWidth: '500px', textAlign: "center" }}>Observation</TableCell>
                              </TableRow>
                              <TableRow sx={{ "& th": stickySubHeaderCellSx }}>
                                    <TableCell sx={{ minWidth: '70px'}} className={classes.tdBordered}>Région <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>District <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>Commune <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center"}}>Fokontany </TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>Lieu</TableCell>
                                    <TableCell sx={{ minWidth: '70px'}} className={classes.tdBordered}>Région <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>District <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>Commune <Bullred/></TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>Fokontany</TableCell>
                                    <TableCell sx={{ minWidth: '70px', textAlign: "center" }}>Lieu</TableCell>
                                    
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {rows.length > 0 &&
                              rows.map((row) => (
                                <TableRow key={row._rowKey}>
                                  <TableCell>
                                      {row?.mission_timesheet_destination_id && row?.is_driver == 1 ? (
                                      <>
                                      <IconButton
                                        color="primary"
                                        onClick={() =>
                                          handleEditDestinationDialog(transport.transport_id, row)
                                        }
                                      >
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                       <IconButton
                                      color="error"
                                      onClick={() => handleRemoveRow(transport.transport_id, row._rowKey)}
                                    >
                                      <CloseIcon />
                                    </IconButton>
                                    </>
                                    ) : null}
                                  </TableCell>
                                  <TableCell>{formatDate(row.date_begin) == formatDate(row.date_end) ? formatDate(row.date_begin) : (formatDate(row.date_begin) + " - " + formatDate(row.date_end))}</TableCell>
                                  <TableCell>{row.heure_begin || '-'}</TableCell>
                                  <TableCell>{row.heure_arrivee || '-'}</TableCell>
                                  <TableCell>{row.region_depart || '-'}</TableCell>
                                  <TableCell>{row.district_depart || '-'}</TableCell>
                                  <TableCell>{row.commune_depart || '-'}</TableCell>
                                  <TableCell>{row.fokontany_depart || '-'}</TableCell>
                                  <TableCell>{row.lieu_depart || '-'}</TableCell>
                                  <TableCell>{row.region_arrivee || '-'}</TableCell>
                                  <TableCell>{row.district_arrivee || '-'}</TableCell>
                                  <TableCell>{row.commune_arrivee || '-'}</TableCell>
                                  <TableCell>{row.fokontany_arrivee || '-'}</TableCell>
                                  <TableCell>{row.lieu_arrivee || '-'}</TableCell>
                                  <TableCell sx={{ borderLeft: "1px solid #e6e6e6"}}>{row.type === "DM" ? <Chip icon={<CardTravelIcon />} label="Mission" variant="outlined" /> : <Chip icon={<TimeToLeaveIcon />} style={{ fontSize: "12px" }} label="Délai de route" variant="outlined"/>}</TableCell>
                                  <TableCell>{ row.code_financement_mis}</TableCell>
                                  <TableCell sx={{minWidth: '130px', textAlign: "center"}}><FormControl fullWidth variant="outlined" size="small">
                            {
                              row?.is_driver == 1 ? (
                            
                           <TextField
                              id="outlined-number"
                              label="Km"
                              type="number"
                              size="small"

                               onChange={(e) => handleChangeKm(e, transport.transport_id, row._rowKey)}
                              value={row?.distance_km ?? ""}
                            /> 
                              ) : (
                                row?.distance_km || '-'  
                              )
                            }
                          </FormControl>
                         </TableCell>
                        {/* <TableCell sx={{ minWidth: '220px', textAlign: "center" }}>
                        <Autocomplete
                              disablePortal
                              id="combo-box-demo"
                              options={transportMeans}
                              getOptionLabel={(option) => option.label}
                              size="small"
                                sx={{
                                "& .MuiAutocomplete-option": {
                                  fontSize: "13px",
                                },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      fontSize: "13px",
                                    },
                                  }}
                                />
                              )}
                              value={
                                transportMeans.find(
                                  (t) => t.value === row?.transport_type
                                ) || null
                              }
                              onChange={(_, newValue) => handleChangeFormValues('transport_type', newValue ? newValue : {}, index)}
                            />
                          
                        </TableCell> */}
                        
                      <TableCell sx={{textAlign: "center"}}>
                         { formatWithThousandSeparator(row.mission_timesheet_details_consumption)} </TableCell>
                          <TableCell sx={{textAlign: "center"}}>
                         {formatWithThousandSeparator(transport.price_per_liter)}
                        </TableCell>
                        <TableCell sx={{textAlign: "center"}}>
                          { formatWithThousandSeparator(row.mission_timesheet_details_amount)}
                          </TableCell>
                       
                        <TableCell sx={{textAlign: "center", borderLeft: "1px solid #e6e6e6"}}>
                          <label style={{fontWeight: 'bold', color: 'purple'}}>{row?.night_number || 0}</label>
                        </TableCell>
                         <TableCell sx={{width: '400px', borderLeft: "1px solid #e6e6e6"}}>
                          <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            value={row?.observation || ""}
                            placeholder='votre commentaire ici ...'
                            multiline
                            rows={2}
                            sx={{
                                    "& .MuiInputBase-input": {
                                      fontSize: "13px",
                                    },
                                  }}
                            // onChange={(e) => handleChangeFormValues('observation', e.target.value, index)}
                            />
                        </TableCell> 
                                </TableRow>
                              ))}
                              {/* <TableRow>
                                <TableCell colSpan={17} align="right">
                                  <strong>Total</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>{totalKm.toFixed(2)}</strong>
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell>
                                  <strong>{totalConsumption.toFixed(2)}</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>{totalAmount.toFixed(2)}</strong>
                                </TableCell>
                                <TableCell colSpan={5}></TableCell>
                              </TableRow> */}
                            </TableBody>
                           </Table>
                          </TableContainer>
                        </Paper>
                      </fieldset>
                    </Grid>
                  );
                })
              ) : (
                <Grid item xs={12}>
                  <Typography color="textSecondary">Aucun transport FID a afficher.</Typography>
                </Grid>
              )}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Box container item xs={6} spacing={2} display="flex" justifyContent="" alignItems="left" sx={{ marginTop: "5px", marginBottom: "5px" }}>
                                                       <span style={{color: "red", marginRight: "24vw"}} ><strong> Veuillez défiler horizontalement le tableau pour voir toutes les colonnes.</strong>
                            </span>  
                                          </Box>
          <Button color="error" onClick={handleCloseDialog} variant="contained" sx={{ marginRight: '16px' }}>
            Annuler
          </Button>
          <Button variant="contained" color="info" onClick={handleSave} startIcon={<SaveIcon />}>
            Enregistrer et envoyer l'OM
          </Button>
        </DialogActions>
      </Dialog>
      <DestinationDriverDialog
        destDialog={destDialog}
        setDestDialog={setDestDialog}
        setMessage={setMessage}
        fetchDestinations={refreshDestinations}
      />
    </MainContainer>
  );
};

export default TimesheetDriver;
